var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heatmap-body"},[_c('div',{staticClass:"iframe-container"},[_c('iframe',{attrs:{"allowfullscreen":"","src":'https://komodo.rentalios.com/heatmap'}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }